const Footer = () => {
  return <>
    <div className="absolute bottom-0 w-full z-20 bg-surface/60 backdrop-blur-md border-t border-outline-variant/20 py-2 px-container-padding flex justify-between items-center pointer-events-none">
        <div className="text-label-sm font-label-sm text-on-surface-variant">
          © 2024 جميع الحقوق محفوظة للمنصة
        </div>
        <div className="text-label-sm font-label-sm text-on-surface-variant">
          v1.0.0
        </div>
      </div>
  </>
}
export default Footer;